import * as React from "react";
import { TPublicationsReportApplicantPresentationModel } from "../../../../presenter/report/model/PublicationsReportApplicantPresentationModel";
import ReactPDF, { Page, View, Text } from "@react-pdf/renderer";
import { TPublicationsReportReportingPeriodPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportingPeriodPresentationModel";
import PublicationsReportPDFReportingPeriod from "./PublicationsReportPDFReportingPeriod";

const PublicationsReportPDFApplicant = ({
  translate,
  applicant,
  styles
}: {
  translate: any;
  applicant: TPublicationsReportApplicantPresentationModel;
  styles: ReactPDF.Styles;
}) => {
  const renderReportingPeriods = () => {
    let reportingPeriods: JSX.Element[] = [];
    applicant.reportingPeriods?.forEach(
      (
        reportingPeriod: TPublicationsReportReportingPeriodPresentationModel
      ) => {
        reportingPeriods.push(
          <PublicationsReportPDFReportingPeriod
            key={`pdf-rp-${reportingPeriod.reportingPeriodId}`}
            translate={translate}
            reportingPeriod={reportingPeriod}
            styles={styles}
          />
        );
      }
    );
    return reportingPeriods;
  };
  return (
    <Page size="A4" style={styles.body} orientation={"portrait"}>
      <View style={styles.titleCol}>
        <Text style={styles.title}>{`${translate(
          "publications_report.applicant.fullname"
        )}: ${applicant.fullname}`}</Text>
      </View>
      <Text style={styles.regularText}>
        {`${translate("publications_report.applicant.father_name")}: ${
          applicant.fatherName
        }`}
      </Text>
      <Text style={styles.regularText}>
        {`${translate("publications_report.applicant.maiden_name")}: ${
          applicant.maidenName
        }`}
      </Text>
      {renderReportingPeriods()}
      <Text
        style={styles.pageNumbers}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  );
};

export default PublicationsReportPDFApplicant;
